<template>
  <el-container v-loading="isLoading" class="Edit">
    <el-header class="Edit-header">
      <el-page-header @back="close" :content="title"></el-page-header>
    </el-header>
    <el-main class="Edit-main">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="广告主账号" prop="userName" style="width: 500px">
          <el-input v-model="form.userName" :disabled="isModel===2"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="passWord" style="width: 500px">
          <el-input v-model="form.passWord" show-password></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="nickName" style="width: 500px">
          <el-input v-model="form.nickName"></el-input>
        </el-form-item>
        <el-form-item label="广告主" prop="adowner">
          <el-select v-model="form.adowner" :disabled="isModel===2">
            <el-option v-for="(item, index) in adowner" :label="item.advertiserName" :value="item.advertiserId" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="联系人" prop="linkman" style="width: 500px">
          <el-input v-model="form.linkman"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="phone" style="width: 500px">
          <el-input v-model.number="form.phone"></el-input>
        </el-form-item>
        <el-form-item label="角色" prop="roleId">
          <el-select v-model="form.roleId">
            <el-option v-for="(item, index) in role" :label="item.roleName" :value="item.roleId" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="remark" style="width: 500px">
          <el-input type="textarea" v-model="form.remark"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('form')">提交</el-button>
          <el-button v-if="isModel!==2" @click="resetForm('form')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-main>
  </el-container>
</template>

<script>
export default {
  name: 'Edit',
  data () {
    let _this = this
    let userNameRule = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入广告主账号'))
      } else {
        // if (!(/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,18}$/.test(value))) {
        //   callback(new Error('账号必须由数字和字母组成，长度为6~18个字符'))
        // } else {
        if (this.isModel !== 2 || this.oldName !== value) {
          _this.$axios({
            method: 'post',
            headers: {
              'Authorization': this.$store.state.user.token,
              'ModuleId': this.thisModule.id
            },
            url: this.myOption.requestUrl + this.thisModule.exists,
            data: _this.qs.stringify({
              userName: value
            })
          }).then((res) => {
            let code = res.data.code
            if (code === 200) {
              if (res.data.data.exists) {
                callback(new Error('广告主账号已存在'))
              } else {
                callback()
              }
            } else {
              _this.myOption.abnormalCode(_this, code)
            }
          }).catch((err) => {
            _this.myOption.abnormalCode(_this, err)
          })
        } else {
          callback()
        }
        // }
      }
    }
    let phoneRule = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入联系电话'))
      } else {
        if (!(/^1[3456789]\d{9}$/.test(value))) {
          callback(new Error('联系电话格式不正确'))
        } else {
          callback()
        }
      }
    }
    return {
      id: '',
      title: '',
      oldName: '',
      role: [],
      adowner: [],
      thisModule: {},
      isModel: this.$store.getters.isEditId,
      isLoading: false,
      form: {
        userName: '',
        passWord: '',
        nickName: '',
        adowner: '',
        linkman: '',
        phone: null,
        roleId: '',
        remark: ''
      },
      rules: {
        userName: [
          { required: true, validator: userNameRule, trigger: 'blur' },
          { min: 2, max: 18, message: '长度在 2 到 18 个字符', trigger: 'blur' }
        ],
        passWord: [
          { required: !this.$store.getters.isEditId, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 18, message: '长度在 6 到 18 个字符', trigger: 'blur' }
        ],
        nickName: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }
        ],
        adowner: [
          { required: true, message: '请选择广告主账号', trigger: 'change' }
        ],
        linkman: [
          { required: true, message: '请输入联系人', trigger: 'blur' },
          { min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }
        ],
        phone: [
          { required: true, validator: phoneRule, trigger: 'blur' }
        ],
        roleId: [
          { required: true, message: '请选择角色', trigger: 'change' }
        ],
        remark: [
          { required: false, message: '请输入备注', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    let thisModule = this.myOption.requestModule.user.children.adUser.children
    if (this.isModel === 2) {
      this.isLoading = true
      this.id = this.$store.state.user.editId
      this.title = '修改广告主账号'
      this.thisModule = thisModule.modify
      this.thisModule.detail = thisModule.detail
      this.getDetail()
    } else {
      this.title = '新建广告主账号'
      this.thisModule = thisModule.add
      this.getRoleList()
      this.getAdownerList()
    }
  },
  methods: {
    close () {
      this.myOption.switchListAndEdit(this, true)
    },
    // 获取广告主列表
    getAdownerList () {
      this.isLoading = true
      this.$axios({
        method: 'post',
        headers: {
          'Authorization': this.$store.state.user.token,
          'ModuleId': this.thisModule.id
        },
        url: this.myOption.requestUrl + this.thisModule.adowner,
        data: this.qs.stringify({
          startPage: 1,
          pageSize: this.myOption.pageSize.max
        })
      }).then((res) => {
        let code = res.data.code
        if (code === 200) {
          this.adowner = res.data.data.data
        } else {
          this.myOption.abnormalCode(this, code)
        }
        this.isLoading = false
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
        this.isLoading = false
      })
    },
    // 获取角色列表
    getRoleList () {
      this.isLoading = true
      this.$axios({
        method: 'post',
        headers: {
          'Authorization': this.$store.state.user.token,
          'ModuleId': this.thisModule.id
        },
        url: this.myOption.requestUrl + this.thisModule.role,
        data: this.qs.stringify({
          startPage: 1,
          pageSize: this.myOption.pageSize.max
        })
      }).then((res) => {
        let code = res.data.code
        if (code === 200) {
          this.role = res.data.data.data
        } else {
          this.myOption.abnormalCode(this, code)
        }
        this.isLoading = false
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
        this.isLoading = false
      })
    },
    // 获取详情信息
    getDetail () {
      this.isLoading = true
      this.$axios({
        method: 'post',
        headers: {
          'Authorization': this.$store.state.user.token,
          'ModuleId': this.thisModule.detail.id
        },
        url: this.myOption.requestUrl + this.thisModule.detail.api,
        data: this.qs.stringify({
          userId: this.id
        })
      }).then((res) => {
        let code = res.data.code
        if (code === 200) {
          let data = res.data.data
          this.oldName = data.userName
          this.form.userName = data.userName
          this.form.nickName = data.nickName
          this.form.companyName = data.companyName
          this.form.linkman = data.linkman
          this.form.phone = data.phone
          this.adowner = [{advertiserName: data.advertiserName, advertiserId: data.advertiserId}]
          this.form.adowner = data.advertiserId
          this.role = [{roleName: data.roleInfoVo.roleName, roleId: data.roleInfoVo.roleId}]
          this.form.roleId = data.roleInfoVo.roleId
          this.form.remark = data.remark
          this.getRoleList()
        } else {
          this.myOption.abnormalCode(this, code)
        }
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
        this.isLoading = false
      })
    },
    // 提交表单
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isLoading = true
          let param = {
            nickName: this.form.nickName,
            advertiserId: this.form.adowner,
            linkman: this.form.linkman,
            phone: this.form.phone,
            roleId: this.form.roleId,
            remark: this.form.remark
          }
          if (this.isModel === 2) {
            param.userId = this.id
            if (this.form.passWord !== '') {
              param.passWord = this.form.passWord
            }
          } else {
            param.userName = this.form.userName
            param.passWord = this.form.passWord
          }
          this.$axios({
            method: 'post',
            headers: {
              'Authorization': this.$store.state.user.token,
              'ModuleId': this.thisModule.id
            },
            url: this.myOption.requestUrl + this.thisModule.api,
            data: this.qs.stringify(param)
          }).then((res) => {
            let code = res.data.code
            this.isLoading = false
            if (code === 200) {
              this.$message.success(`${this.isModel === 2 ? '修改' : '新建'}广告主账号成功`)
              this.$router.push({path: this.$route.path.replace('/edit', '/list')})
            } else {
              this.myOption.abnormalCode(this, code)
            }
          }).catch((err) => {
            this.isLoading = false
            this.myOption.abnormalCode(this, err)
          })
        } else {
          return false
        }
      })
    },
    // 重置表单
    resetForm (formName) {
      this.$refs[formName].resetFields()
    }
  },
  beforeDestroy () {
    this.$store.dispatch('SetEditId', false)
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ad_user/Edit.vue